var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container, TextBox, useModal } from "@animech/ui";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingModal } from "../../loading-modal/loading-modal";
import * as Styled from "./delete-modal-base.style";
import { CustomConfirmModal } from "ui/components/modals/custom-confirm-modal/custom-confirm-modal";
export var DeleteModalBase = function (_a) {
    var props = __rest(_a, []);
    var onShouldClose = props.onShouldClose, performDelete = props.performDelete, translationKey = props.translationKey, customContent = props.customContent, confirmationText = props.confirmationText, itemName = props.itemName;
    var t = useTranslation().t;
    var openModal = useModal();
    var _b = __read(useState(""), 2), confirmInput = _b[0], setConfirmInput = _b[1];
    var translate = function (key, options) {
        return t("".concat(translationKey, ".").concat(key), options);
    };
    var onDeleteSystem = useCallback(function () {
        var deleteSystem = function () { return __awaiter(void 0, void 0, void 0, function () {
            var loadingModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingModal = openModal(_jsx(LoadingModal, { translationKey: "".concat(translationKey, ".loading_delete") }));
                        return [4 /*yield*/, performDelete()];
                    case 1:
                        _a.sent();
                        loadingModal.close();
                        onShouldClose && onShouldClose(true);
                        return [2 /*return*/];
                }
            });
        }); };
        deleteSystem();
    }, [onShouldClose, openModal, performDelete, translationKey]);
    return (_jsxs(CustomConfirmModal, __assign({ title: translate("title"), cancelActionLabel: t("modal.close"), okActionLabel: translate("confirm_button_label"), color: "inverted", cancelButtonProps: { color: "primary" }, confirmButtonProps: {
            color: "primary",
            onClick: onDeleteSystem,
            disabled: confirmationText !== undefined && confirmInput !== confirmationText,
        }, hideCloseButton: false }, props, { children: [customContent ? (customContent) : (_jsx(Container, { children: translate("text", { name: itemName }) })), confirmationText ? (_jsxs(Container, { children: [_jsxs("p", { children: [translate("confirm_input_needed_1"), _jsx(Styled.DeletionConfirmationText, { children: confirmationText }), translate("confirm_input_needed_2")] }), _jsx(TextBox, { value: confirmInput, instantValueChange: true, onValueChange: setConfirmInput })] })) : null] })));
};
